'use client';
import { useParams } from 'next/navigation';

import type { Locale } from '@/i18n/routing';

/** /{locale}/~ 을 위해 매번 useParams 하고 타입 가져오는게 귀찮았음 */
const useLocaleLink = () => {
	const { locale } = useParams() as { locale: Locale };

	return locale;
};

export default useLocaleLink;
